import React from "react";

export default function BgLogo({ className = "", variant = "horizontal", size = 36 }) {
  // variant: "horizontal" (logo + wordmark) | "mark" (logo only)
  const src = "/assets/bigradap-logo.png";
  if (variant === "mark") {
    return (
      <img
        src={src}
        alt="Bigradap Group Technologies"
        style={{ width: size, height: size }}
        className={`block object-contain ${className}`}
        data-testid="bg-logo-mark"
        loading="eager"
      />
    );
  }
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="bg-logo">
      <img
        src={src}
        alt="Bigradap"
        style={{ width: size, height: size }}
        className="block object-contain drop-shadow-[0_0_12px_rgba(230,0,0,0.35)]"
        loading="eager"
      />
      <div className="flex flex-col leading-none">
        <span className="font-heading text-[15px] font-medium tracking-tight text-white">
          BIGRADAP
        </span>
        <span className="font-mono text-[9px] tracking-[0.25em] text-brand-textDim">
          GROUP TECHNOLOGIES
        </span>
      </div>
    </div>
  );
}
